import { Button } from "@rumble-it/common-components/components";
import { Link } from "react-router-dom";
import { Checkbox } from "@/components/form/checkbox";

type Action = {
  id: string;
  rule: {
    name: string;
  };
  ruleActionType: {
    name: string;
  };
  name: string;
  description: string;
  data: string;
  priority: number;
  active: boolean;
  delayInSeconds: number;
  synchronous: boolean;
};
export const formatActions = (data: Action[]) =>
  data ? data.map((item) => formatAction(item)) : null;

export const formatAction = (item: Action) => ({
  id: item.id,
  rule: item.rule?.name,
  ruleActionType: item.ruleActionType?.name,
  name: <Link to={`/rules/actions/${item.id}`}>{item.name}</Link>,
  description: item.description,
  data: item.data,
  priority: item.priority,
  //@ts-expect-error - Checkbox expects a boolean
  active: <Checkbox checked={item.active} />,
  delayInSeconds: item.delayInSeconds,
  //@ts-expect-error - Checkbox expects a boolean
  synchronous: <Checkbox checked={item.synchronous} />,
  // Preferable allow the table to handle the link?
  show: (
    <Link to={`/rules/actions/${item.id}`}>
      <Button
        variant="greyLight"
        size="iconSmall"
        faIcon={{ style: "fal", name: "eye" }}
      />
    </Link>
  ),
});

export const formatActionTypesAsSelect = (
  data: { id: string | number; name: string }[],
) =>
  data
    ? data.map((item) => ({
        id: item,
        name: item,
      }))
    : null;
